import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useEffect, useState } from "react";

export interface LinkItemProps {
  icon: any;
  url: string;
}

export const LinkItem = ({ icon, url }: LinkItemProps) => {
  return (
    <NavLink
      to={url}
      className="relative inline-flex items-center font-medium text-center text-teal-500"
    >
      <FontAwesomeIcon icon={icon} className="block text-1xl p-3 has-badge" />
    </NavLink>
  );
};

const TopNav = () => {
  return (
    <nav className="z-10 fixed w-full inset-x-0 top-0">
      <div className="relative z-10 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
          <div className="relative flex items-center justify-between h-16">
            <div className="flex items-center px-2 lg:px-0">
              <NavLink to={"/"}>
                <img
                  className="block lg:hidden h-6 w-auto"
                  src="./iheredesign4.svg"
                  alt="Logo"
                />
                <img
                  className="hidden lg:block h-6 w-auto"
                  src="./iheredesign4.svg"
                  alt="Logo"
                />
              </NavLink>
            </div>
            <div className="flex justify-end">
              {/* <LinkItem icon={solid("search")} url={"/explorer"} /> */}
              <LinkItem icon={solid("plus-square")} url={"/create"} />
              <LinkItem icon={solid("heart")} url={"/"} />
              <NavLink
                to={"/cart"}
                className="relative inline-flex items-center font-medium text-center text-teal-500"
              >
                <FontAwesomeIcon
                  icon={solid("shopping-bag")}
                  className="block text-1xl p-3 has-badge"
                />
                <span className="sr-only">Notifications</span>
                <div className="absolute inline-flex items-center justify-center w-5 h-5 text-xs font-semibold text-white bg-red-600 border-2 border-white rounded-full top-0 right-0 ">
                  {0}
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

const TopNavWithSearch = () => {
  const [search, setSearch] = useState("");

  useEffect(() => {
    // console.log(search);
  }, [search]);

  return (
    <nav className="z-10 fixed w-full inset-x-0 top-0">
      <div className="relative z-10 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
          <div className="relative flex items-center justify-center h-16">
            <div className="flex justify-end">
              <div className="relative w-full max-w-xl focus-within:text-gray-600">
                <div className="absolute inset-y-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <FontAwesomeIcon
                      icon={solid("search")}
                      className="block text-1xl p-3 has-badge"
                    />
                  </button>
                </div>
                <input
                  className="block w-full pl-8 pr-4 py-2 border rounded-lg appearance-none leading-normal"
                  type="text"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export { TopNav, TopNavWithSearch };

export default TopNav;
